import { roleLevel } from '../../hooks/usePermissionEnforcement';
import type { SecurityRole } from '../../types/user';

/**
 * Extra role levels a route needs when the connection is in Enforce mode, keyed by the route's own
 * security field (SecureRoute and the navigation both read it). The API stages the same rule
 * (docs/roadmap/permission-ui-alignment.md); in Audit and Off nothing changes.
 *
 * The resident pages: every patient read they make needs Resident 1 AND Dietech_Level 1, the
 * desktop's Dietech master switch (frmDietech_Resident_DataGrid_V2.vb:352-366;
 * PatientController [StagedRoleLevel(RoleLevel.DietechMain, 1)]).
 */
export const STAGED_ROUTE_RULES: Readonly<Record<string, { field: keyof SecurityRole; min: number }>> = {
  dietech_Resident_Level: { field: 'dietech_Level', min: 1 },
};

/** False only when enforced and the route's staged rule is not met. */
export function stagedRouteAllows(enforced: boolean, role: SecurityRole | null | undefined, securityField: string): boolean {
  const rule = STAGED_ROUTE_RULES[securityField];
  if (!enforced || !rule) return true;
  return roleLevel(role, rule.field) >= rule.min;
}
